import { Col, Modal, Row } from 'antd';
import React, { ReactElement } from 'react';
import { DELAYED_POPUP_MSG_DOD, GUTTOR_SPACE } from '../../constants/commonConstants';
import FormTextArea from '../crmFormElement/FormTextArea/FormTextArea';
import Text from 'antd/lib/typography/Text';
import { updateDefaultTimeline } from '../../../store/actions/newAdmissionAction';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store';

const PopuponLateDod = (props: any): ReactElement => {
  const { onCancelPopConfirm, visible, setVisible, form, lengthOfStay } = props;
  const dispatch = useDispatch();
  const defaultTimeline = useSelector((state: RootState): any => state?.newAdmission?.defaultTimeline || {});

  const onOkHandler = (): any => {
    form.validateFields(['LOSgt90'])
      .then((): any => {
        defaultTimeline.remarks['Remarks for LOS >90 days'] = (form.getFieldsValue(['LOSgt90'])?.LOSgt90);
        dispatch(updateDefaultTimeline(defaultTimeline));
        setVisible(false);
      });
  };

  const onCancelHandler = (): any => {
    form.resetFields(['LOSgt90']);
    defaultTimeline.remarks['Remarks for LOS >90 days'] = undefined;
    dispatch(updateDefaultTimeline(defaultTimeline));
    onCancelPopConfirm();
  };

  return (
    <div>
      <Modal
        title={`Justification for length of stay ${lengthOfStay} days`}
        centered={true}
        visible={visible}
        onOk={onOkHandler}
        onCancel={onCancelHandler}
        okText="Add"
        cancelText="Cancel"
      >
        <Row gutter={GUTTOR_SPACE}>
          <Col md={24}>
            {DELAYED_POPUP_MSG_DOD}
          </Col>
        </Row>
        <Row>
          <Col md={24} className="mt-sm">
            <Text type="secondary" className="fsize_sm">Remarks</Text>
          </Col>
        </Row>
        <Row gutter={GUTTOR_SPACE}>
          <FormTextArea detail={{
            ...props,
            size: 24,
            key: 'LOSgt90',
            onchange,
            hideLabel: true,
          }} />
        </Row>
      </Modal>
    </div>
  );
};
export default PopuponLateDod;
